import { useState } from "react";
import {
  Platform,
  TextInput as RNTextInput,
  StyleSheet,
  View,
} from "react-native";

import { useCustomTheme } from "@luna-restaurant/ui";

import { parseGuestOrderMenuQuantityInput } from "@/components/forms/guestOrderMenuQuantity";

type GuestOrderMenuQuantityInputProps = {
  value: number;
  onChange: (nextValue: number) => void;
};

export function GuestOrderMenuQuantityInput({
  value,
  onChange,
}: GuestOrderMenuQuantityInputProps) {
  const { colors, fonts } = useCustomTheme();
  const [isFocused, setIsFocused] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const hasValue = value > 0;
  const isFocusActive = isFocused;
  const isHoverActive = isHovered;

  const borderColor =
    isFocusActive || isHoverActive
      ? colors.palette.spinach30
      : hasValue
        ? colors.palette.spinach40
        : colors.mutedBorder;
  const borderWidth =
    isFocusActive || isHoverActive || hasValue ? 1 : undefined;

  const hoverHandlers =
    Platform.OS === "web"
      ? {
          onMouseEnter: () => setIsHovered(true),
          onMouseLeave: () => setIsHovered(false),
        }
      : undefined;

  return (
    <View
      {...(hoverHandlers as any)}
      style={[
        styles.container,
        {
          borderColor,
          backgroundColor: colors.background,
        },
        ...(borderWidth !== undefined ? [{ borderWidth }] : []),
        Platform.OS === "web" &&
          (isHoverActive || isFocusActive) &&
          ({
            outlineStyle: "solid",
            outlineWidth: 2,
            outlineOffset: -1,
            outlineColor: borderColor,
          } as any),
      ]}
    >
      <RNTextInput
        value={String(value)}
        style={[
          styles.input,
          fonts.bold,
          { color: colors.text },
          Platform.OS === "web" && ({ outlineStyle: "none" } as any),
        ]}
        keyboardType="numeric"
        inputMode="numeric"
        maxLength={3}
        selectTextOnFocus
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onChangeText={(nextValue) =>
          onChange(parseGuestOrderMenuQuantityInput(nextValue))
        }
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: 56,
    height: 44,
    borderRadius: 12,
    paddingHorizontal: 8,
    justifyContent: "center",
  },
  input: {
    width: "100%",
    lineHeight: 20,
    paddingVertical: 0,
    textAlign: "center",
    fontSize: 15,
  },
});
